
import { Component, Vue } from "vue-property-decorator";
import { HealthProductService,UserService,WechatService } from "src/services";
import { Toast, Dialog } from "vant";
import { Pay, tools } from "src/utils";
import sensors from "src/sensors";
Component.registerHooks([
    "beforeRouteEnter",
    "beforeRouteLeave",
    "beforeRouteUpdate" // for vue-router 2.2+
]);

@Component
export default class GoodsDetail extends Vue
{
    /**
     * 数据模型
     * @private
     * @returns any
     */
    protected dataModel: any = {
        bannerPicts:"",
        bannerPictsUrls:[],
        id:null,
        infoPicts:"",
        infoPictsUrls:[],
        introduce:"",
        isNeedAppointment: false,
        mainPict:"",
        mainPictUrl:"",
        marketPrice: null,
        name:"", 
        price:null,
        remark:"",
        supplierId:null,
        supplierName: "",
        isPut: true,
    };

    /**
     * 选中tab值
     * @private
     * @returns string
     */
    private active: string = "";

    

    /**
     * 跳转权益购买id
     * @private
     * @returns string
     */
    private get isRightsIdToBuy(): string
    {
        return this.$route.query && (this.$route.query.isRightsIdToBuy as string) || "";
    }

    /**
     * 商品详情id
     * @private
     * @returns string
     */
    private get id(): string
    {
        return this.$route.query && (this.$route.query.id as string) || "";
    }

    /**
     * 产品id
     * @private
     * @returns string
     */
    private get productId(): string
    {
        return this.$route.query && (this.$route.query.productId as string) || "";
    }

    /**
     * 权益id
     * @private
     * @returns string
     */
     private get rightsId(): string
    {
        return this.$route.query && (this.$route.query.rightsId as string) || "";
    }

    /**
     * 是否详情
     * @private
     * @returns boolean
     */
     private get isDetail(): boolean
    {
        return this.$route.query && (this.$route.query.isDetail as any) || false;
    }

    /**
     * 获取当前登入机构信息
     * @private
     * @returns void
     */
     private get orgInfo(): any
    {
        return this.$store.getters.orgInfo || {};
    }

    /**
     * 组件创建钩子
     * @protected
     * @returns void
     */
    protected created()
    {
        this.getHealthProductDetail(this.id);
        sensors.track('GJ_tg_details_exposure');
    }

    /**
     * 组件进来之前
     * @private
     * @returns void
     */
    private beforeRouteEnter(to, from, next): void
    {
        let appid = localStorage.getItem("appid");
        if (!tools.isAndroid() && `/${appid}${to.path}` !== location.pathname)
        {
           location.assign(`/${appid}${to.fullPath}`);
        }
        else
        {
            next();
        }
    }

    /**
     * 点击购买
     * @protected
     * @returns void
     */
    protected onBuy()
    {
        this.$router.push({name: "goods-order-submit", query:{ id: this.id,rightsId: this.rightsId, productId: this.productId }});
    }

    /**
     * 获取健康产品详情
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getHealthProductDetail(id: string): Promise<void>
    {
        try
        {
            const isRights = this.rightsId ? true : null;
            let {content: result} = await HealthProductService.instance.getHealthProductDetail(id,isRights);
            if(result.data)
            {
                this.dataModel = result.data;
                this.shareData.name = this.dataModel.name;
                this.shareData.price = this.dataModel.price;
                this.shareData.marketPrice = this.dataModel.marketPrice;
                this.shareData.qrCode = window.location.href;
                if(this.dataModel.bannerPictsUrls && this.dataModel.bannerPictsUrls.length> 0)
                {
                    this.shareData.bannerUrl = this.dataModel.bannerPictsUrls[0] || "";
                    this.getUrl2base64(this.dataModel.bannerPictsUrls[0]);
                }
            }
        }
        catch(err)
        {
            Toast(JSON.stringify(err));
        }

    }

    /**
     * 是否显示分享弹出框
     * @private
     * @returns boolean
     */
    private showSharePopup: boolean = false;

    /**
     * 分享弹出框数据
     * @private
     * @returns any
     */
    private shareData: any = {
        name: "",
        price: null,
        marketPrice: null,
        qrCode: "",
        posterUrl: "",
        bannerUrl: ""
    };

    /**
     * 获取url获取base64
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getUrl2base64(url: string): Promise<void>
    {
        try
        {
            let {content: result} = await UserService.instance.url2base64(url);
            if(result.data)
            {
                this.shareData.posterUrl = "data:image/png;base64," + result.data;
            }
        }
        catch(err)
        {
            Toast(JSON.stringify(err));
        }
    }

}
